import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_API_URL') private baseApiUrl: string
  ) {}

  getConfig(): Observable<{ enabled: boolean }> {
    return this.http.get<{ enabled: boolean }>(`${this.baseApiUrl}/captcha/config`);
  }

  verify(token: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.baseApiUrl}/captcha/verify`, { token });
  }
}
